import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { getAgencySettings, handleNavigate } from "../utils/common";
import useAuth from "../hooks/useAuth";

function Header() {
  const navigate = useNavigate();
  const { companyInfo } = useAuth();
  const location = useLocation();
  const currentLocation = location.pathname;
  const [searchParams] = useSearchParams();
  const parentAgency = searchParams.get("agency") || null;
  const [mobnavOpen, setMobNavopen] = useState(false);
  const toggleMobileMenu = () => {
    setMobNavopen((prev) => !prev);
  };
  const closeAndNavigate = (route = "/") => {
    toggleMobileMenu();
    handleNavigate(navigate, route, currentLocation);
  };
  // const [agencySettings, setAgencySettings] = useState(null)

  // useEffect(() => {
  //     if (!!parentAgency) {
  //         handleGetAgencySettings()
  //     }
  // }, []);

  // const handleGetAgencySettings = async () => {
  //     let res = await getAgencySettings(parentAgency)
  //     setAgencySettings(res.res.data.data)
  // }

  return (
    <header className="gbl-header">
      <div className="container">
        <a
          className="brand-logo"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleNavigate(navigate, "/", currentLocation);
          }}
        >
          <img
            className=""
            src={!!parentAgency ? companyInfo?.logo : "/images/bottbuddy.png"}
            alt="Logo"
          />
        </a>
        {/* <Link  to="/">
                    <img className="" src={!!parentAgency ? companyInfo?.logo : "/images/bottbuddy.png"} alt="Logo" />
                </Link> */}

        <div className="menu-grid">
          <nav className="site-nav">
            <ul className="site-menu">
              <li className={currentLocation == "/" ? "active" : ""}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigate(navigate, "/", currentLocation);
                  }}
                >
                  Home
                </a>
              </li>
              <li className={currentLocation == "/features" ? "active" : ""}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigate(navigate, "/features", currentLocation);
                  }}
                >
                  Features
                </a>
              </li>
              <li className={currentLocation == "/pricing" ? "active" : ""}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigate(navigate, "/pricing", currentLocation);
                  }}
                >
                  Pricing
                </a>
              </li>
              <li
                className={currentLocation == "/documentation" ? "active" : ""}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigate(navigate, "/documentation", currentLocation);
                  }}
                >
                  Documentation
                </a>
              </li>
              {/* {!parentAgency && (
                <li className={currentLocation=="/affiliate"?"active":""}>
                  <a
                    href="#"
                    onClick={() =>
                      handleNavigate(navigate, "/affiliate", currentLocation)
                    }
                  >
                    Become an affiliate
                  </a>
                </li>
              )} */}
              <li className={currentLocation == "/contact-us" ? "active" : ""}>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigate(navigate, "/contact-us", currentLocation);
                  }}
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>
          <button className="navToggle" onClick={() => toggleMobileMenu()}>
            <span className="hamburger-menu">
              <span className="bar"></span>
            </span>
          </button>

          {/* Mobile Nav Header  */}
          <nav className={`mobnav-grid ${mobnavOpen ? "open-mobile-nav" : ""}`}>
            <a
              href="#"
              className="mobnav-close navToggle"
              onClick={(e) => {
                e.preventDefault();
                toggleMobileMenu();
              }}
            >
              <img src="/images/cross-icon-w.png" alt="cross-icon-white" />
            </a>
            <ul>
              <li className="">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    closeAndNavigate();
                  }}
                >
                  Home
                </a>
              </li>
              <li className="">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    closeAndNavigate("/features");
                  }}
                >
                  Features
                </a>
              </li>
              <li className="">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    closeAndNavigate("/pricing");
                  }}
                >
                  Pricing
                </a>
              </li>
              <li className="">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    closeAndNavigate("/documentation");
                  }}
                >
                  Documentation
                </a>
              </li>
              {/* {!parentAgency && (
                <li className="">
                  <a
                    href="#"
                    onClick={() => closeAndNavigate("/affiliate")}
                  >
                    Become an affiliate
                  </a>
                </li>
              )} */}
              <li className="">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    closeAndNavigate("/contact-us");
                  }}
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="group-user-cta">
          <a
            href="#"
            className="cta-"
            onClick={(e) => {
              e.preventDefault();
              handleNavigate(navigate, "/login", currentLocation);
            }}
          >
            Sign In
          </a>

          <a
            href="#"
            className="cta-primary"
            onClick={(e) => {
              e.preventDefault();
              handleNavigate(navigate, "/signup", currentLocation);
            }}
          >
            Create Account
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
